export const ROOMS = [
    'HAB.1',
    'HAB.2',
    'HAB.3',
    'HAB.4',
    'HAB.5',
    'HAB.6',
    'HAB.7',
    'HAB.8',
    'HAB.9',
    'HAB.10',
    'HAB.11',
    'HAB.12',
    'HAB.13',
    'HAB.14',
    'HAB.15',
    'HAB.16',
    'HAB.17',
    'HAB.18',
    'HAB.19',
    'HAB.20',
    'HAB.21',
    'HAB.22',
    'HAB.23',
    'HAB.24',
    'HAB.25',
    'HAB.26',
    'HAB.27',
    'HAB.28',
    'HAB.29',
    'HAB.30',
    'HAB.31',
    'HAB.32',
    'HAB.33',
    'HAB.34',
]
